/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
export const PROFILE_ID = "30015e38-0e8c-4f6a-8363-cea3c93a60ee";

/* queries */
export const queryGetProfile = `query getProfile($profile_id: String!){
  getProfile(profile_id: $profile_id) {
    FirstName
    LastName
    Email
    Address1
    Address2
    City
    State
    Zipcode
    Country {
      Continent
      ID
      Name
      ShortSize
    }
  }
}
`;

export const mutationUpdateProfile = `mutation updateProfile(
  $profile_id: String!,
  $FirstName: String,
  $LastName: String,
  $Email: String,
  $Address1: String,
  $City: String,
  $State: String,
  $Zipcode: String
) {
  updateProfile(profile: {
    ID: $profile_id,
    FirstName: $FirstName,
    LastName: $LastName,
    Email: $Email,
    Address1: $Address1,
    City: $City,
    State: $State,
    Zipcode: $Zipcode
  }){
    FirstName,
    Address1
  }
}
`
